module.exports = __webpack_public_path__ + "img/Phone_SMVS.cf4545c4.png";